module.exports = __webpack_public_path__ + "img/xiangkuang.26658674.png";